import {isFilteredSelector} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'

/**
 * Empty list component for the Stocktake list page.
 *
 * @param {Object} props - The component props.
 * @param {String} props.colSpan - The number of columns to span.
 *
 * @returns {React.ReactElement} The rendered component.
 */
export default function EmptyList({colSpan}) {
  const isFiltered = useSelector(isFilteredSelector)

  return (
    <tr className="table__tr">
      <td className="table__td" colSpan={colSpan}>
        <div className="padding-top-25 padding-bottom-25 align-center">
          <strong className="text--md-grey fs-02 lh-md">
            {isFiltered
              ? 'No Stocktakes match the current search terms.'
              : 'There aren’t any Stocktakes.'}
          </strong>
        </div>
      </td>
    </tr>
  )
}
